import { render, staticRenderFns } from "./systempatch.vue?vue&type=template&id=07094ed3&scoped=true&"
import script from "./systempatch.vue?vue&type=script&lang=js&"
export * from "./systempatch.vue?vue&type=script&lang=js&"
import style0 from "./systempatch.vue?vue&type=style&index=0&id=07094ed3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07094ed3",
  null
  
)

export default component.exports